module.exports = __webpack_public_path__ + "img/Sound5.91e402e4.png";